import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Col } from 'react-bootstrap';
import ShipmentDiscountsEdit from './editing/ShipmentDiscountsEdit';
import ShipmentTransferEdit from './editing/ShipmentTransferEdit';
import Text from '../Text';
import Card from '../Card';
import FreightValuesContext, { useFreightValues } from './context';
import NegotiatedValuesAttendedEdit from './editing/NegotiatedValuesAttendedEdit';
import HeaderShow from './show/HeaderShow';
import SummaryPayingTransporterCardShow from './show/SummaryPayingTransporterCardShow';

const FreightValuesRef = forwardRef(({ cargoValue, shippingCompany, isNational }, ref) => {
  const {
    init,
    getValues,
    setCargoValue,
    onChangeShippingCompany,
    setInsuranceValueBenner,
    errors,
    setCustomerFields,
    convertValueToCurrency
  } = useFreightValues();

  const [isNegotiatedValuesOpen, setIsNegotiatedValuesOpen] = useState(true);

  useEffect(() => {
    onChangeShippingCompany(shippingCompany);
  }, [shippingCompany]);

  useImperativeHandle(ref, () => ({
    getValues,
    init,
    setInsuranceValueBenner,
    errors,
    setCustomerFields,
    convertValueToCurrency
  }));

  useEffect(() => {
    setCargoValue(cargoValue);
  }, [cargoValue]);

  function onToggleNegotiatedCard() {
    setIsNegotiatedValuesOpen(!isNegotiatedValuesOpen);
  }

  return (
    <Col xs={12}>
      <Card
        header={<Text type="header">Composição de valores de frete</Text>}
        bodyCardPadding="2rem"
      >
        <HeaderShow isNational={isNational} />
        <NegotiatedValuesAttendedEdit
          defaultIsOpen={isNegotiatedValuesOpen}
          onChangeIsOpen={onToggleNegotiatedCard}
        />
        <ShipmentDiscountsEdit defaultIsOpen />
        <ShipmentTransferEdit defaultIsOpen isAttended />
        <SummaryPayingTransporterCardShow />
      </Card>
    </Col>
  );
});

export default forwardRef(({ 
  cargoValue, 
  shippingCompany, 
  isNational 
}, ref) => {
  return (
    <FreightValuesContext>
      <FreightValuesRef
        ref={ref}
        cargoValue={cargoValue}
        shippingCompany={shippingCompany}
        isNational={isNational}
      />
    </FreightValuesContext>
  );
});
